import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en' // 导入项目中用到的英文语言包
import cnLocale from './cn' // 导入项目中用到的简体中文语言包
import tcLocale from './tc' // 导入项目中用到的繁体中文语言包
import krLocale from './kr' // 导入项目中用到的韩文语言包
Vue.use(VueI18n)
const messages = {
  en: {
    ...enLocale
  },
  cn: {
    ...cnLocale
  },
  tc: {
    ...tcLocale
  },
  kr: {
    ...krLocale
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'cn', // 设置语种
  messages, // 设置全局当地语言包,
  fallbackLocale: 'cn'
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js